import { NgModule } from '@angular/core';
import {RSDebuggerService} from './rsdebugger.service';


@NgModule({
  providers: [
      [RSDebuggerService]
  ]
})
export class RSDebuggerModule {

}
